import React from 'react';
import {
    Alert,
    Button,
    Form,
    FormGroup,
    Input,
    Label,
    ListGroup,
    ListGroupItem,
    ListGroupItemHeading,
    ListGroupItemText, ModalFooter
} from 'reactstrap';
import { setTitle } from './util';
import mfgFetch from "./mfg-fetch";

class ManufacturerSettings extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            logs: [],
            preferences: [],
            alertState: false,
            alertMessage: "",
        };

        this.dismissAlert = this.dismissAlert.bind(this);

    }

    componentWillMount() {
    }


    componentDidMount() {
        setTitle('Settings & Logging');
        this.grabLogs();
        this.grabPreferences();
    }

    dismissAlert() {
        this.setState({
            alertState: false,
        });
    }

    setAlertMessage(msg) {
        this.setState({
            alertMessage: msg
        });
    }

    grabPreferences() {
        mfgFetch('/api/v1/mfg/preferences', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                if (body) {
                    this.setState({
                        preferences: body,
                    });
                }
            })
            .catch((err) => {
                console.error("Could not get preferences", err);
            });
    }

    grabLogs() {
        mfgFetch('/api/v1/mfg/logs', {
            method: 'GET'
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                if (body) {
                    this.setState({
                        logs: body,
                    });
                }
            })
            .catch((err) => {
                console.error("Could not get activity logs", err);
            });

    }

    validateForm() {
        // @TODO validate input?
        return true;
    }

    submitPreferences(e) {
        e.preventDefault();

        const data = new FormData(e.target);

        this.setState({
            formInvalid: false,
            submitFailed: false
        });

        if (!this.validateForm()) {
            this.setState({
                formInvalid: true
            });
            return;
        }

        mfgFetch('/api/v1/mfg/preferences', {
            method: 'POST',
            body: data,
        })
            .then(async (resp) => {
                this.grabPreferences();
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
            })
            .catch((err) => {
                this.grabPreferences();
                console.error("Could not update preferences", err);
            });

    }

    render() {

        let logs = [];
        if (this.state.logs) {
            for (let log of this.state.logs) {
                let date = new Date(log.activity_created);
                let options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' };

                logs.push(
                    <ListGroupItem>
                        <ListGroupItemHeading>{date.toLocaleString("default", options)}</ListGroupItemHeading>
                        <span className="d-flex flex-row">
                            <ListGroupItemText className="log-user"><b>User: {log.activity_username}</b></ListGroupItemText>
                            <ListGroupItemText className="flex-fill align-self-center">{log.activity_message}</ListGroupItemText>
                        </span>
                    </ListGroupItem>
                );
            }
        }

        let currentLogo = (
            <b>No current logo, upload one below.</b>
        );
        if (this.state.preferences.hasOwnProperty("preferences_logo") && this.state.preferences.preferences_logo !== "") {
            currentLogo = (
                <span>
                    <Label><b>Current Logo</b></Label>
                    <img width="120" height="60" src={this.state.preferences.preferences_logo} />
                </span>
            );
        }

        let tempLogo = null;
        if (this.state.preferences.hasOwnProperty("preferences_temp_logo") && this.state.preferences.preferences_temp_logo !== "") {
            tempLogo = (
                <span>
                    <Label><b>Awaiting Approval</b></Label>
                    <img width="120" height="60" src={this.state.preferences.preferences_temp_logo} />
                </span>
            );
        }

        return (
            <div className="d-flex flex-column">
                <span>
                    <Alert className="mx-auto m-1" color="success" isOpen={this.state.alertState} toggle={this.dismissAlert}>
                        {this.state.alertMessage}
                    </Alert>
                </span>
                <span>
                    <div className="d-flex flex-row justify-content-around p-1">
                        <span className="settings p-1">
                            <h3>Settings</h3>
                            <div className="d-flex flex-column">
                                <div className="d-flex flex-column">
                                    <h5 className="align-self-center">Logo</h5>
                                    <div className="d-flex flex-row justify-content-around">
                                        {currentLogo}
                                        {tempLogo}
                                    </div>
                                </div>
                            </div>

                            <Form onSubmit={(e) => this.submitPreferences(e)} className="mfg-settings-form">
                                <FormGroup>
                                    <span className="d-flex flex-row p-1">
                                        <Label className="content-label pr-1">Logo:</Label>
                                        <Input
                                            type="file"
                                            name="logo"
                                        />
                                    </span>
                                    <span className="d-flex flex-row justify-content-center p-1">
                                        <Button color="info">Save Settings</Button>
                                    </span>
                                </FormGroup>
                            </Form>
                        </span>

                        <span className="activity-log flex-fill p-1">
                            <h3>Activity Log</h3>
                            <ListGroup>
                                {logs}
                            </ListGroup>
                        </span>

                    </div>
                </span>
            </div>
        );
    }
}

export default ManufacturerSettings;